module.exports = __webpack_public_path__ + "static/img/db10_pc.0486b96f.jpg";